import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4b439b04"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "home bgImg" };
const _hoisted_2 = /*#__PURE__*/ _createStaticVNode("<div class=\"leftBox\" data-v-4b439b04><div class=\"loveBox\" data-v-4b439b04><p style=\"text-align:left;\" data-v-4b439b04>To 啾啾:</p><div class=\"text\" data-v-4b439b04><p id=\"ptext\" data-v-4b439b04><span id=\"sp1\" data-v-4b439b04></span><span id=\"sp2\" data-v-4b439b04>_</span></p></div></div></div>", 1);
const _hoisted_3 = { class: "rightBox" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "只愿得一人心，白首不分离。啾啾，今天已经是我们在一起的", -1));
const _hoisted_5 = { class: "timeSpan" };
const _hoisted_6 = { class: "timeSpan" };
const _hoisted_7 = { class: "timeSpan" };
const _hoisted_8 = { class: "timeSpan" };
const _hoisted_9 = { class: "case" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", {
    href: "https://beian.miit.gov.cn",
    style: { "padding": "20px 0", "height": "20px", "line-height": "20px", "float": "right", "color": "#939393" }
}, "闽ICP备2022001975号-1", -1));
const _hoisted_11 = { style: { "width": "300px", "margin": "0 auto", "padding": "20px 0", "float": "left" } };
const _hoisted_12 = {
    target: "_blank",
    href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35018102000631",
    style: { "display": "inline-block", "text-decoration": "none", "height": "20px", "line-height": "20px" }
};
const _hoisted_13 = ["src"];
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { style: { "float": "left", "height": "20px", "line-height": "20px", "margin": "0px 0px 0px 5px", "color": "#939393" } }, "闽公网安备 35018102000631号", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", null, [
                _createTextVNode(" 第 "),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.days), 1),
                _createTextVNode(" 天 "),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.hours), 1),
                _createTextVNode(" 小时 "),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.minutes), 1),
                _createTextVNode(" 分钟 "),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.seconds), 1),
                _createTextVNode(" 秒 ")
            ])
        ]),
        _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
                _createElementVNode("a", _hoisted_12, [
                    _createElementVNode("img", {
                        src: _ctx.batbLogo,
                        style: { "float": "left" }
                    }, null, 8, _hoisted_13),
                    _hoisted_14
                ])
            ])
        ])
    ]));
}
